module.exports = __webpack_public_path__ + "static/media/29ADMSPC16.94441b0a.jpg";